import { type ChangeEvent, useCallback } from 'react'
import { IconButton, InputAdornment, TextField } from '@mui/material'
import { Search, Close } from '@mui/icons-material'

import { useTexts } from '../../../../../hooks/useTexts'

interface Props {
  filter: string
  onChangeFilter: (search: string) => void
}

export function Header(props: Props) {
  const { filter, onChangeFilter } = props
  const texts = useTexts()

  const handleOnSearch = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => onChangeFilter(e.target.value),
    [onChangeFilter],
  )

  const onCancel = useCallback(() => onChangeFilter(''), [onChangeFilter])
  const hideResetButton = filter === ''

  return (
    <TextField
      id="filter-devices"
      data-testid="filter-devices"
      placeholder={texts.integrationDevicesTable.header.placeholder}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Search />
          </InputAdornment>
        ),
        endAdornment: (
          <InputAdornment position="end" hidden={hideResetButton}>
            <IconButton onClick={onCancel} size="small">
              <Close />
            </IconButton>
          </InputAdornment>
        ),
      }}
      variant="standard"
      onChange={handleOnSearch}
      value={filter}
      sx={{
        width: 220,
      }}
    />
  )
}
